import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

const ONBOARDING_MODAL_NAME = 'ai_notetaker_free_trial_start_modal'
const AUTO_LOAD_LOC = 'auto_load'
const FLOW_NAME = 'ai_notetaker_setup_flow'
const SET_RECORDING_RULES = 'set_recording_rules'


export const mrOnboardingTrackingAcknowledgement = {
  AUTO_LOAD_SHOWN: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    properties: {
      modal_name: ONBOARDING_MODAL_NAME,
      location: AUTO_LOAD_LOC,
      action: 'opening'
    }
  },
  AUTO_LOAD_CONTINUE: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    properties: {
      modal_name: ONBOARDING_MODAL_NAME,
      location: AUTO_LOAD_LOC,
      action: 'ai_notetaker_free_trial_started'
    }
  },
  AUTO_LOAD_SAMPLE: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    properties: {
      modal_name: ONBOARDING_MODAL_NAME,
      location: AUTO_LOAD_LOC,
      action: 'see_sample_recap',
    }
  },
  AUTO_LOAD_DISMISSED: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    properties: {
      modal_name: ONBOARDING_MODAL_NAME,
      location: AUTO_LOAD_LOC,
      action: 'dismissed'
    }
  },
  USER_TRIG_CONTINUE: {
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: FLOW_NAME,
      flow_step: 'ai_notetaker_acknowledgement',
      completion_method: 'step_completed',
      flow_version: 'v2'
    }
  },
  USER_TRIG_CONTINUE_FREE_EMAIL: {
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: FLOW_NAME,
      flow_step: 'ai_notetaker_acknowledgement',
      completion_method: 'step_completed',
      flow_version: 'v2_freemail'
    }
  },
  FREE_EMAIL_COMPLETE: {
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: FLOW_NAME,
      flow_step: 'ai_notetaker_acknowledgement',
      completion_method: 'auto_skipped',
      flow_version: 'v2_freemail',
      flow_step_value: null
    }
  },
}
export const mrOnboardingTrackingRecordingRules = {
  CONTINUE: {
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: FLOW_NAME,
      flow_step: SET_RECORDING_RULES,
      completion_method: 'step_skipped',
      flow_version: 'v2'
    }
  },
  CONTINUE_WITH_CHANGES: {
    name: TRACKING_EVENT_NAMES.FLOW_STEP_COMPLETED,
    properties: {
      flow_name: FLOW_NAME,
      flow_step: SET_RECORDING_RULES,
      completion_method: 'step_completed',
      flow_version: 'v2',
      flow_step_value: null,
    }
  },
  AUTO_LOAD_DISMISSED: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    properties: {
      modal_name: ONBOARDING_MODAL_NAME,
      location: AUTO_LOAD_LOC,
      action: 'dismissed'
    }
  },
}

export const userSettingsTrackingV3 = {
  valuesSaved: {
    name: TRACKING_EVENT_NAMES.SETTING_UPDATED,
    props: {
      setting_name: 'ai_notetaker_recording_rules',
      location: 'ai_notetaker_settings'
    }
  },

  disableModalOpen: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    props: {
      modal_name: 'disable_ai_notetaker',
      location: 'ai_notetaker_settings',
      action: 'opening'
    }
  },

  disableModalDismiss: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    props: {
      modal_name: 'disable_ai_notetaker',
      location: 'ai_notetaker_settings'
    }
  },

  deleteModalOpen: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    props: {
      modal_name: 'delete_ai_notetaker_data',
      location: 'ai_notetaker_settings',
      action: 'opening'
    }
  },

  deleteModalConfirm: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    props: {
      modal_name: 'delete_ai_notetaker_data',
      location: 'ai_notetaker_settings',
      action: 'ai_notetaker_data_deleted'
    }
  },

  deleteModalDismiss: {
    name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
    props: {
      modal_name: 'delete_ai_notetaker_data',
      location: 'ai_notetaker_settings'
    }
  }
}

export const sampleRecapButtonTracking = {
  recapsPage: {
    name: TRACKING_EVENT_NAMES.CTA_CLICKED,
    props: {
      action: 'view_sample_recap',
      cta_destination: 'sample_meeting_recap',
      cta_key: 'recaps_page',
      cta_text: 'see_a_sample_recap',
    }
  },
  settingsPage: {
    name: TRACKING_EVENT_NAMES.CTA_CLICKED,
    props: {
      action: 'view_sample_recap',
      cta_destination: 'sample_meeting_recap',
      cta_key: 'ai_notetaker_settings',
      cta_text: 'see_a_sample_recap',
    }
  },
}
